<template>
  
</template>
<script>
export default {
  name: 'redirect',
  beforeCreate() {
    this.$router.replace({
      path: this.$route.query.path,
    })
    
  },
}
</script>
